module.exports = __webpack_public_path__ + "static/8-min-b8dd7c2c54368e819282e54dac5a61a5.jpg";